import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { FormModalBaseComponent } from '../../../../../../core/base/components/form-modal-base/form-modal-base.component';
import { EstablishmentModel } from '../../../../../../core/models/establishment.model';
import { EstablishmentService } from '../../establishment.service';
import { SnackbarService } from '../../../../../../core/services/snackbar.service';
import icClose from '@iconify/icons-ic/twotone-close';

@Component({
  selector: 'vex-establishment-need-delete',
  templateUrl: './establishment-need-delete.component.html',
  styleUrls: ['./establishment-need-delete.component.scss'],
})
export class EstablishmentNeedDeleteComponent extends FormModalBaseComponent<EstablishmentModel> implements OnInit {
  generic: any;
  type: 'product' | 'prestation';
  dependencies: any;
  hasDependencies = false;
  readonly icClose = icClose;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<FormModalBaseComponent<EstablishmentModel>>,
    public establishmentService: EstablishmentService,
    public snackbarService: SnackbarService,
  ) {
    super(data, dialogRef, establishmentService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.generic = this.data.generic;
    this.type = this.data.type;
    this.dependencies = this.data.dependencies;
    this.hasDependencies = !!this.dependencies?.hasDependencies;
  }

  deleteItem() {
    this.loading = true;
    const request =
      this.type === 'product'
        ? this.establishmentService.deleteGenericProduct(this.defaults._id, this.generic._id)
        : this.establishmentService.deleteGenericPrestation(this.defaults._id, this.generic._id);
    const sub = request.subscribe(
      res => {
        this.snackbarService.success('Le besoin a bien été supprimé !');
        this.afterDeleteItem(res, null);
        this.loading = false;
      },
      err => {
        this.setErrorsMessages(err.error?.errors);
        this.loading = false;
      },
    );
    this.subscription.add(sub);
  }

  close(data?: any): void {
    this.dialogRef.close(data);
  }
}
